var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarnesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 45,
    viewBox: "0 0 148 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7744 18.6446C14.7744 17.3311 13.8571 17.027 12.4262 17.027H9.78442V20.6757H13.4535C14.4687 20.2743 14.7744 19.2527 14.7744 18.6446Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9521 24.3243H9.78442V27.973H12.6586C14.3464 27.973 15.1413 27.2797 15.1413 26.1C15.1413 24.823 14.3464 24.3243 12.9521 24.3243Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.86487V40.1351H23.2377V4.86487H0ZM14.5664 31.6216H4.89216V12.1622H14.1261C18.1254 12.1622 20.4614 14.0473 20.4614 17.1365C20.4614 18.9122 19.2384 20.5662 17.7952 21.223C19.3485 21.7703 21.024 23.1081 21.024 26.0878C21.0118 29.1892 18.5657 31.6216 14.5664 31.6216Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8137 0V12.1622H62.1182C65.9218 12.1622 68.8693 14.1446 68.8693 18.0122C68.8693 20.5541 67.6096 22.8162 65.506 23.6432L71.083 31.6216H64.8211L61.1275 25.5405H57.4828V31.6216H53.8137V45H95.3971V0H53.8137ZM90.5049 31.6216H85.1847L78.2745 20.2865V31.6216H73.3823V12.1622H78.7026L85.6127 23.6311V12.1622H90.5049V31.6216Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.647 18.7905C63.647 17.1121 62.5952 15.8108 60.2347 15.8108H57.4829V21.8919H61.2376C62.6808 21.8919 63.647 20.3716 63.647 18.7905Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1782 25.5405H36.5934L34.4164 18.0608L32.1782 25.5405Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5759 9.72974V18.073L32.1536 13.3784H37.9875L44.0294 32.3027V32.8378H38.7948L37.853 29.1892H31.2119L30.5759 31.8649V36.4865H46.4754V9.72974H30.5759Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.512 9.72974V13.3784H113.743V17.027H106.404V20.6757H112.52V24.3243H106.404V29.1892H113.743V32.8378H101.512V36.4865H117.412V9.72974H101.512Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.162 26.8662C132.162 25.65 131.648 25.273 129.826 24.6649L127.795 24.0081C126.805 23.6797 125.631 23.1811 125.985 22.1716V27.6568C125.851 28.2041 127.6 28.6297 129.116 28.6297C131.452 28.6176 132.162 27.9608 132.162 26.8662Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.973 4.86487V15.4338C127.245 14.0351 129.422 13.2932 132.186 13.2932C133.617 13.2932 135.965 13.8405 136.98 14.6189V18.2432H136.577C135.562 17.5865 133.409 17.2459 131.978 17.2459C130.547 17.2459 129.324 17.6838 129.324 18.7905C129.324 19.8851 129.96 20.2257 130.657 20.4446L132.7 21.1014C135.048 21.8676 138.008 22.7554 138.008 27.1459C138.008 30.7703 135.451 33.0811 130.351 33.0811C129.128 33.0811 127.257 32.7649 125.985 32.1932V40.1351H148V4.86487H125.973Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnesLogo);
export default __webpack_public_path__ + "static/media/Barnes_logo.6cfbf8c57f93a77d36a92cdc7ca0d7d7.svg";
export { ForwardRef as ReactComponent };